import { arrayOf, shape } from "prop-types";

import __ from "web/Layout/Translations";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import { SOURCE_FOUND_LABEL } from "web/constants/benefits";

import classify from "web/classify";

import defaultClasses from "./fundingSource.scss";

const FundingSource = ({ classes, fundingSourceData }) => {
  return (
    <>
      {isArrayHasItems(fundingSourceData) && fundingSourceData?.length > 1 && (
        <span className={classes.columnOne__label} data-t1="fundingSource">
          {__("Współfinansowany")}
        </span>
      )}
      {isArrayHasItems(fundingSourceData) &&
        fundingSourceData?.map((ele) =>
          // TODO: create fundingSourceData as array of objects & add data-t1 attributes to all labels
          typeof ele === "string" ? (
            <div
              /* eslint-disable-next-line react/no-array-index-key */
              key={ele}
              className={
                fundingSourceData.length > 1 ? classes.columnOne__value : ""
              }
            >
              {ele}
            </div>
          ) : (
            <div
              /* eslint-disable-next-line react/no-array-index-key */
              key={ele.label}
              className={
                fundingSourceData.length > 1 ? classes.columnOne__value : ""
              }
              data-t1={ele.dataT1}
            >
              {ele.label}
            </div>
          )
        )}
      {isArrayHasItems(fundingSourceData) &&
        fundingSourceData?.[0] === SOURCE_FOUND_LABEL.employee && (
          <span className={classes.employeeSubText}>
            {__(SOURCE_FOUND_LABEL.employeeSubText)}
          </span>
        )}
    </>
  );
};

FundingSource.propTypes = {
  classes: shape({}).isRequired,
  fundingSourceData: arrayOf(shape({})).isRequired,
};

export default classify(defaultClasses)(FundingSource);
